import React from "react";
import {
  Page,
  Text,
  Document,
  StyleSheet,
  Font,
  View,
} from "@react-pdf/renderer";
import "../../../utilits/helpers/numberToWord";
import "@fontsource/roboto";
import numberToPhrase from "../../../utilits/helpers/numberToWord";
import petrovich from "petrovich";
import PTSerifItalic from "../../../fonts/PTSerif-Italic.ttf";
import PTSerifBoldItalic from "../../../fonts/PTSerif-BoldItalic.ttf";
import PTSerifBold from "../../../fonts/PTSerif-Bold.ttf";

Font.register({
  family: "PTSerif",
  fonts: [
    { src: PTSerifItalic, fontStyle: "italic", fontWeight: "normal" },
    { src: PTSerifBoldItalic, fontStyle: "italic", fontWeight: "bold" },
    { src: PTSerifBold, fontStyle: "normal", fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    margin: "10px 0",
    fontSize: 12,
    textAlign: "center",
    fontFamily: "PTSerif",
    fontStyle: "italic",
    fontWeight: "bold",
  },
  mainTitle: {
    margin: 30,
    fontSize: 12,
    textAlign: "center",
    fontFamily: "PTSerif",
    fontStyle: "italic",
    fontWeight: "bold",
  },
  paragraph: {
    textIndent: "20px",
  },
  text: {
    fontSize: 12,
    textAlign: "justify",
    fontFamily: "PTSerif",
    fontStyle: "italic",
    fontWeight: "normal",
  },
  textItalicBold: {
    fontSize: 12,
    textAlign: "justify",
    fontFamily: "PTSerif",
    fontStyle: "italic",
    fontWeight: "bold",
  },
  rowText: {
    marginTop: 3,
    fontSize: 12,
    textAlign: "left",
    fontFamily: "PTSerif",
    fontStyle: "italic",
    fontWeight: "normal",
  },
  rowTextTitleLeft: {
    marginTop: 3,
    fontSize: 12,
    textAlign: "left",
    fontFamily: "PTSerif",
    fontStyle: "italic",
    fontWeight: "bold",
  },
  rowTextTitleRight: {
    marginTop: 3,
    fontSize: 12,
    textAlign: "right",
    fontFamily: "PTSerif",
    fontStyle: "italic",
    fontWeight: "bold",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  systemInfo: {
    position: "absolute",
    fontSize: 8,
    bottom: 30,
    left: 20,
    right: 0,
    textAlign: "left",
    color: "grey",
    fontFamily: "PTSerif",
    fontStyle: "italic",
    fontWeight: "normal",
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  left: {
    width: "50%",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "auto",
  },
  right: {
    width: "50%",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "auto",
  },
});

const PDFFile = ({
  organization,
  contragent,
  protocol,
  docDate,
  numberDogovor,
  identCode,
  dateDogovorTo,
  square,
  purpose,
  address,
  totalSum,
  zemNalog,
  procent,
  paymentCodes,
  phone,
}) => {
  const person = {
    first: organization.attributes.name,
    middle: organization.attributes.lastname,
    last: organization.attributes.surname,
  };

  const convertToRuFormat = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("ru-RU");
  };

  const genitiveName = petrovich(person, "genitive");
  return (
    <Document>
      <Page style={styles.body}>
        <View style={styles.row}>
          <View style={styles.left}>
            <Text style={styles.rowTextTitleLeft}>г. Кара-Балта</Text>
            <Text style={styles.rowTextTitleLeft}>Кыргызская Республика</Text>
          </View>
          <View style={styles.right}>
            <Text style={styles.rowTextTitleRight}> </Text>
            <Text style={styles.rowTextTitleRight}>
              от {convertToRuFormat(docDate)}
            </Text>
          </View>
        </View>
        <Text style={styles.mainTitle}>
          Договор аренды земельного участка №{numberDogovor}
        </Text>
        <Text style={styles.text}>
          <Text style={{ ...styles.paragraph, ...styles.textItalicBold }}>
            Мы, Учреждение “{organization.attributes.title}” (далее-“
            {organization.attributes.shortTitle}”)
          </Text>{" "}
          (юридический адрес: {organization.attributes.address} регистрационный
          номер {organization.attributes.regNumber}, ИНН:{" "}
          {organization.attributes.inn}), представляющее имущественные интересы
          мэрии города Кара-Балта согласно Устава{" "}
          {organization.attributes.shortTitle} в лице{" "}
          {organization.attributes.leader}{" "}
          <Text style={styles.textItalicBold}>
            {genitiveName.last} {genitiveName.first} {genitiveName.middle}
          </Text>
          , именуемый(ая) в дальнейшем
          <Text style={styles.textItalicBold}> «Арендодатель»</Text>
        </Text>
        <Text style={styles.text}>
          <Text style={{ ...styles.paragraph, ...styles.textItalicBold }}>
            И гражданин (ка) Кыргызской Республики, {contragent.surname}{" "}
            {contragent.name} {contragent.lastname},{" "}
            {convertToRuFormat(contragent.birthday)} года рождения,{" "}
            {contragent.passport}, персональный номер {contragent.inn},
          </Text>{" "}
          зарегистрированный(ая) по адресу: {contragent.address}, с другой
          стороны, именуемый(ая) в дальнейшем{" "}
          <Text style={styles.textItalicBold}>«Арендатор»</Text> заключили
          настоящий договор о нижеследующем:
        </Text>
        <Text style={styles.title}>1. Предмет договора.</Text>
        <Text style={styles.text}>
          1.1. <Text style={styles.textItalicBold}>«Арендодатель»</Text> на
          основании {protocol}{" "}
          <Text style={styles.textItalicBold}>«Арендатору»</Text> право
          временного пользования земельным участком под идентификационным кодом{" "}
          <Text style={styles.textItalicBold}>{identCode}</Text> до{" "}
          <Text style={styles.textItalicBold}>
            {convertToRuFormat(dateDogovorTo)}
          </Text>{" "}
          года, площадью{" "}
          <Text style={styles.textItalicBold}>
            {square} кв.м., {purpose}
          </Text>
          , расположенный по адресу:{" "}
          <Text style={styles.textItalicBold}>город Кара-Балта {address}</Text>.
        </Text>
        <Text style={styles.title}>2. Арендный платеж и другие платежи.</Text>
        <Text style={styles.text}>
          2.1. Арендатор в соответствии с настоящим договором и в соответствии
          со ст. 8 и 14 Земельного Кодекса Кыргызской Республики, а также
          Законом Кыргызской Республики «О муниципальной собственности на
          имущество», обязуется вносить арендную плату в размере{" "}
          <Text style={styles.textItalicBold}>
            {parseFloat(totalSum)} сом ({numberToPhrase(parseFloat(totalSum))})
            на 1(один) год. Расчет по арендной плате составляется ежегодно с
            первых чисел начала года.
          </Text>
        </Text>
        <Text style={styles.text}>
          2.2. В соответствии{" "}
          <Text style={styles.textItalicBold}>со ст. 404</Text> Налогового
          кодекса Кыргызской Республики за земельный участок переданного в
          аренду, земельный налог несельскохозяйственного назначения выплачивает
          Арендодатель, и взимает с Арендатора в рамах договора аренды
          зем/участка с выделением в договоре суммы зем/налога.{" "}
          <Text style={styles.textItalicBold}>
            Сумма земельного налога несельскохозяйственного назначения{" "}
            {zemNalog} ({numberToPhrase(parseFloat(zemNalog))}) сом в год.
            Оплата производится на ИНН Арендодателя{" "}
            {organization.attributes.inn}.
          </Text>
        </Text>
        <Text style={styles.text}>
          2.3. Арендная плата выплачивается с момента предоставления права
          аренды на земельный участок, не позднее 5 (пятого) числа каждого
          квартала равными долями.
        </Text>
        <Text style={styles.text}>
          2.4. Арендная плата выплачивается в порядке, установленном пунктом 2.1
          настоящего договора, без каких-либо дополнительных уведомлений или
          требований со стороны Арендодателя.
        </Text>
        <Text style={styles.text}>
          2.5. Арендодатель вправе увеличивать размер арендной платы не чаще
          одного раза в год.
        </Text>
        <Text style={styles.text}>
          2.6. Платежи и иные расходы, связанные с подписанием настоящего
          Договора или подлежащие уплате в соответствии с нормативными правовыми
          актами Кыргызской Республики и актами мэрии города Кара-Балта, несет
          Арендатор.
        </Text>
        <Text style={styles.text}>
          2.7. При первичном предоставлении права аренды или права собственности
          на земельный участок, в соответствии с пунктом 31 главы 5 Типового
          положения о порядке и условиях возмездного предоставления прав
          собственности или аренды на земельные участки, находящиеся в
          муниципальной собственности, утвержденного Постановлением
          Правительства Кыргызской Республики от 23 сентября 2011 года № 571,
          Арендатор обязан в течении 5 рабочих дней со дня подписания настоящего
          договора оплатить расходы {organization.attributes.shortTitle} при
          мэрии города Кара-Балта, связанные с формированием земельного участка,
          согласно смете расходов на формирование земельного участка на
          расчетный счет {organization.attributes.shortTitle}.
        </Text>
        <Text style={styles.text}>
          2.8. Арендатору разрешается на предоставленном земельном участке
          возводить только строения и сооружения облегченного типа.
        </Text>
        <Text style={styles.text}>
          2.9. Вырубку, пересадку, сан. обрезку деревьев и зеленых насаждений
          производить только по согласованию с{" "}
          {organization.attributes.shortTitle} при мэрии города Кара-Балта.
        </Text>
        <Text style={styles.title}>
          3. Ответственность сторон. Порядок разрешения споров.
        </Text>
        <Text style={styles.text}>
          3.1 За неисполнение или ненадлежащее исполнение обязательств по
          настоящему Договору, стороны несут ответственность в порядке,
          установленном законодательством Кыргызской Республики.
        </Text>
        <Text style={styles.text}>
          3.2. Своевременно вносить арендные платежи за пользование земельным
          участком, при нарушении обязательств по уплате арендных платежей
          начисляется пеня согласно{" "}
          <Text style={styles.textItalicBold}>
            Статьи 35. Пеня КОДЕКСА КЫРГЫЗСКОЙ РЕСПУБЛИКИ О ПРАВОНАРУШЕНИЯХ
          </Text>{" "}
          в размере {procent.neustoika} от суммы задолженности за каждый день
          просрочки. Уплата штрафа и пени не освобождает Арендатора от уплаты
          основной суммы за аренду земельного участка.
        </Text>
        <Text style={styles.text}>
          3.3. Арендодатель не отвечает за те недостатки сданного в аренду
          земельного участка, которые были оговорены при заключении настоящего
          Договора или были известны Арендатору либо должны были быть обнаружены
          им во время осмотра земельного участка при заключении настоящего
          договора или передачи его в аренду.
        </Text>
        <Text style={styles.text}>
          3.4. В случае порчи либо нанесения ущерба арендованному земельному
          участку Арендатор возмещает Арендодателю причиненный ущерб в порядке,
          установленном законодательством Кыргызской Республики.
        </Text>
        <Text style={styles.text}>
          3.5. . В случае неисполнения Арендатором других условий настоящего
          Договора Арендодатель выдает письменное уведомление Арендатору об
          устранении нарушений. Арендатор обязан устранить нарушения в течении
          30 (тридцати календарных дней) со дня получения письменного
          уведомления. В случае неисполнения Арендатором требований, указанных в
          письменном уведомлении Арендодатель вправе подать исковое заявление в
          суд о расторжении настоящего договора.
        </Text>
        <Text style={styles.text}>
          3.6. Арендатор должен использовать земельный участок по целевому
          назначению, и содержать в надлежащем порядке прилегающею территорию в
          радиусе 6 метров, а также ежегодно производить ремонт и
          архитектурно-художественное оформление сооружения.
        </Text>
        <Text style={styles.text}>
          3.7. Арендатор обязан в течении месяца с момента подписания настоящего
          Договора заключить договор с уполномоченной организацией на вывоз
          твердо-бытовых отходов.
        </Text>
        <Text style={styles.text}>
          3.8. Арендатор не вправе передавать земельный участок в субаренду.
        </Text>
        <Text style={styles.text}>
          3.9. Стороны освобождаются от ответственности за частичное или полное
          использование обстоятельств по настоящему Договору, если это
          неисполнение следствием обязательств непреодолимой силы возникшие
          заключения Договора, в результате событий чрезвычайного характера,
          наступления которых сторона исполнявшая обязательство или частично, не
          могла не предвидеть и не предотвратить разумными путями (форс-мажор).
        </Text>
        <Text style={styles.text}>
          3.10. В случаях, предусмотренных пунктом 3.9 настоящего Договора,
          после выполнения обязательств по настоящему Договору по требованию
          стороны должны быть продлены на срок, равный времени действия таких
          форс-мажорных обстоятельств.
        </Text>
        <Text style={styles.text}>
          3.11. Все споры, которые могут возникнуть в процессе хозяйственной
          деятельности Арендатора, стороны должны разрешить путем переговоров.
        </Text>
        <Text style={styles.text}>
          3.12. Если согласие не будет достигнуто, споры разрешаются в судебном
          порядке в соответствии с законодательством Кыргызской Республики.
        </Text>
        <Text style={styles.title}>
          4. Изменение и расторжение договора. Возврат земельного участка.
        </Text>
        <Text style={styles.text}>
          4.1 В случае принятия Генерального плана развития города до окончания
          срока договора аренды земельного участка, возникшие споры о судьбе
          земельного участка разрешаются путем переговоров. Если согласие не
          будет достигнуто, то спор разрешается в установленном Законом порядке.
        </Text>
        <Text style={styles.text}>
          4.2 При прекращении настоящего Договора Арендатор обязан вернуть
          арендованный земельный участок в том состоянии, в котором он его
          получил, с учетом нормального износа.
        </Text>
        <Text style={styles.text}>
          4.3 В случае не возврата или несвоевременного возврата, Арендатором
          арендованного земельного участка, Арендодатель вправе требовать с
          Арендатора внесения платы за фактическое пользование, за все время
          просрочки. В случае, когда указанная плата не покрывает причиненных
          Арендодателю убытков, он может потребовать их возмещения.
        </Text>
        <Text style={styles.text}>
          4.4 Арендатор без согласия Арендодателя не вправе производить
          самовольное расширение предоставленного в аренду земельного участка. В
          случае самовольного расширения, предоставленного в аренду земельного
          участка Арендатор обязан за собственные средства устранить предмет
          самовольного расширения в течении 30 (тридцати календарных дней) со
          дня письменного уведомления. В случае не устранения предмета
          самовольного расширения Арендодатель вправе обратиться в суд о
          расторжении настоящего договора.
        </Text>
        <Text style={styles.text}>
          4.5. Изъятие для государственных или муниципальных нужд и прекращение
          настоящего Договора, в связи с этим производится в случаях и порядке,
          установленном законодательством Кыргызской Республики.
        </Text>
        <Text style={styles.title}>5. Прочие условия</Text>
        <Text style={styles.text}>
          5.1 Споры возникающие из настоящего Договора, стороны обязуются
          разрешать путём переговоров. В случае невозможности разрешения споров
          путём переговоров, они подлежат разрешению в судебном порядке в
          соответствии с законодательством Кыргызской Республики.
        </Text>
        <Text style={styles.text}>
          5.2 Стороны должны уведомлять друг друга о любых изменениях своего
          юридического адреса, номеров телефонов, телефаксов, не позднее 10
          (десяти) дней со дня изменения.
        </Text>
        <Text style={styles.text}>
          5.3 Настоящий договор вступает в силу с момента его подписания обеими
          сторонами.
        </Text>
        <Text style={styles.text}>
          5.4 Все изменения и дополнения к Договору рассматриваются сторонами в
          месячный срок, и осуществляются только в письменной форме, оформляются
          в виде дополнительного соглашения, что является составной частью
          настоящего договора.
        </Text>
        <Text style={styles.text}>
          5.5. Арендатор обязан письменно уведомить арендодателя о желании
          продлить срок действия договора на новый срок, за месяц до окончания
          действия настоящего договора. В случае не предоставления письменного
          уведомления до окончания срока действия договора, настоящий договор
          считается расторгнутым.
        </Text>
        <Text style={styles.text}>
          5.6 Договор составляется в 3 (трех) экземплярах, имеющих одинаковую
          юридическую силу. Один экземпляр остается у Арендодателя, второй - у
          Арендатора, третий - передается в Жайылский филиал Службы земельных
          ресурсов при МСХ КР.
        </Text>
        <Text style={styles.title}>6. Реквезиты сторон</Text>
        <View style={styles.row}>
          <View style={styles.left}>
            <Text style={styles.rowText}>АРЕНДОДАТЕЛЬ:</Text>
            <Text style={styles.rowText}>
              {organization.attributes.shortTitle} мэрии города Кара-Балта
            </Text>
            <Text style={styles.rowText}>
              {organization.attributes.address}
            </Text>
            <Text style={styles.rowText}>
              ИНН {organization.attributes.inn}
            </Text>
            <Text style={styles.rowText}>
              ОКПО {organization.attributes.okpo}
            </Text>
            <Text style={styles.rowText}>
              БИК {organization.attributes.bik}
            </Text>
            <Text style={styles.rowText}>
              Л. Счет {organization.attributes.ls}
            </Text>
            <Text style={styles.rowText}>{organization.attributes.bank}</Text>
            <Text style={styles.rowText}>Код платежа:</Text>
            {paymentCodes.map((paymentCode) => {
              return (
                <Text style={styles.rowText} key={paymentCode.id}>
                  {paymentCode.attributes.title}: {paymentCode.attributes.code}
                </Text>
              );
            })}
            <Text style={styles.rowText}>
              __________________{organization.attributes.name.charAt(0)}.{" "}
              {organization.attributes.surname}
            </Text>
            <Text style={styles.rowText}>М.П.</Text>
          </View>
          <View style={styles.right}>
            <Text style={styles.rowText}>АРЕНДАТОР:</Text>
            <Text style={styles.rowText}>
              {contragent.name} {contragent.surname} {contragent.lastname}
            </Text>
            <Text style={styles.rowText}>{contragent.address}</Text>
            <Text style={styles.rowText}>{contragent.passport}</Text>
            <Text style={styles.rowText}>
              персональный номер {contragent.inn}
            </Text>
            <Text style={styles.rowText}>
              телефон: {phone}
            </Text>
            <Text style={styles.rowText}>
              __________________{contragent.name.charAt(0)}.{" "}
              {contragent.surname}
            </Text>
            <Text style={styles.rowText}>М.П.</Text>
          </View>
        </View>
        <Text style={{ ...styles.text, margin: "50px 0 20px 0" }}>
          Исп. Юрист Ф.И.О.__________________
        </Text>
        <Text style={styles.textItalicBold}>
          “_____” ______________ {new Date().getFullYear()} года настоящий
          договор аренды удостоверен и подписан сторонами в присутствии
          государственного регистратора ______________________, личность сторон
          устанволена, дееспособность проверена ______________(подпись)
        </Text>
        <Text style={styles.systemInfo} fixed>
          Cформирован АИС-Аренда
        </Text>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPage }) => `${pageNumber}`}
          fixed
        />
      </Page>
    </Document>
  );
};

export default PDFFile;
